'use client'

import { useState, useSyncExternalStore } from 'react'

export type SequenceStart = {
  // Epoch ms the interstitial sequence counts from.
  startedAt: number
  // The overlay arrived in the server HTML, so it was on screen before hydration
  // and must render already entered rather than fade in a second time.
  fromServerHtml: boolean
}

function subscribe() {
  return () => {}
}

// Chrome reports `first-paint`; Safari only reports `first-contentful-paint`,
// which the server-rendered phrase triggers.
function firstPaintTime(): number {
  const [entry] = [
    ...performance.getEntriesByName('first-paint'),
    ...performance.getEntriesByName('first-contentful-paint'),
  ]

  return entry ? performance.timeOrigin + entry.startTime : Date.now()
}

// On a document load the user has watched the server-rendered overlay since
// first paint, so the sequence (and the overlay's floor) counts from then, not
// from hydration, which lands a second or more later on a phone. A client-side
// navigation mounts fresh and counts from mount.
export function useSequenceStart(): SequenceStart {
  // The server snapshot is only read on the server and during hydration.
  const hydrating = useSyncExternalStore(
    subscribe,
    () => false,
    () => true,
  )
  const [start] = useState<SequenceStart>(() => ({
    fromServerHtml: hydrating,
    startedAt:
      hydrating && typeof window !== 'undefined'
        ? firstPaintTime()
        : Date.now(),
  }))

  return start
}
